import { useState } from "react";
import { FaEye, FaEyeSlash } from "react-icons/fa";
import { toast } from "react-toastify";
import { useAuth } from "../Context/AuthContext";
import { Base_URL, tempURl } from "../url";

const Login2 = () => {
  const { login } = useAuth();

  const [username, setUsername] = useState("");
  const [password, setPassword] = useState("");
  const [loading, setLoading] = useState(false);
  const [showPassword, setShowPassword] = useState(false);
  const [showSignup, setShowSignup] = useState(false);
  const [showChangePassword, setShowChangePassword] = useState(false);
const styles = {
  page: {
    height: "100vh",
    background: "#cfe0ee",
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
    fontFamily: "Segoe UI, sans-serif",
  },
  card: {
    width: 360,
    background: "#a9c6e8",
    padding: 28,
    borderRadius: 14,
    textAlign: "center",
    boxShadow: "0 15px 30px rgba(0,0,0,0.15)",
  },
  logo: {
    width: 150,
    
  },
  title: {
    color: "#fff",
    marginBottom: 20,
  },
  input: {
    width: "100%",
    padding: 12,
    borderRadius: 8,
    border: "none",
    marginBottom: 12,
  },
  passwordBox: {
    position: "relative",
  },
  eye: {
    position: "absolute",
    right: 12,
    top: 14,
    cursor: "pointer",
  },
  button: {
    width: "100%",
    padding: 12,
    borderRadius: 8,
    border: "none",
    background: "#0b4d91",
    color: "#fff",
    fontWeight: 600,
    cursor: "pointer",
  },
  microsoftBtn: {
    marginTop: 10,
    width: "100%",
    padding: 10,
    borderRadius: 8,
    border: "none",
    background: "#fff",
    cursor: "pointer",
  },
  link: {
    marginTop: 10,
    fontSize: 13,
    cursor: "pointer",
    color: "#0b4d91",
  },
  overlay: {
    position: "fixed",
    inset: 0,
    background: "rgba(0,0,0,0.4)",
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
  },
};
  // ---------------- PASSWORD LOGIN ----------------
  const handleLogin = async (e) => {
    e.preventDefault();
    setLoading(true);

    try {
      await login(username, password);
    } catch (err) {
      toast.error(err.message || "Invalid credentials");
    } finally {
      setLoading(false);
    }
  };

  // ---------------- MICROSOFT LOGIN ----------------
  const handleMicrosoftLogin = () => {
    window.location.href = `${tempURl}/auth/microsoft/login`;
  };

  // ---------------- SIGNUP ----------------
  const SignupForm = () => {
    const [data, setData] = useState({
      username: "",
      email: "",
      password: "",
    });
    const [showPwd, setShowPwd] = useState(false);

    const submitSignup = async (e) => {
      e.preventDefault();
      setLoading(true);

      try {
        const res = await fetch(`${Base_URL}/Signup`, {
          method: "POST",
          headers: { "Content-Type": "application/json" },
          body: JSON.stringify(data),
        });

        if (res.ok) {
          toast.success("Signup successful. Please login.");
          setShowSignup(false);
        } else {
          toast.error("Signup failed");
        }
      } catch {
        toast.error("Something went wrong");
      } finally {
        setLoading(false);
      }
    };

    return (
      <div style={styles.card}>
        <h2 style={styles.title}>Sign Up</h2>

        <input
          style={styles.input}
          placeholder="Username"
          onChange={(e) => setData({ ...data, username: e.target.value })}
        />
        <input
          style={styles.input}
          placeholder="Email"
          onChange={(e) => setData({ ...data, email: e.target.value })}
        />

        <div style={styles.passwordBox}>
          <input
            style={styles.input}
            type={showPwd ? "text" : "password"}
            placeholder="Password"
            onChange={(e) => setData({ ...data, password: e.target.value })}
          />
          <span onClick={() => setShowPwd(!showPwd)} style={styles.eye}>
            {showPwd ? <FaEyeSlash /> : <FaEye />}
          </span>
        </div>

        <button style={styles.button} onClick={submitSignup}>
          Sign Up
        </button>

        <p style={styles.link} onClick={() => setShowSignup(false)}>
          Back to Login
        </p>
      </div>
    );
  };

  // ---------------- CHANGE PASSWORD ----------------
  const ChangePassword = () => {
    const [data, setData] = useState({
      userName: "",
      password: "",
      confirmPassword: "",
    });

    const submit = async (e) => {
      e.preventDefault();
      setLoading(true);

      try {
        const res = await fetch(`${Base_URL}/Logins/UpdatePassword`, {
          method: "PUT",
          headers: { "Content-Type": "application/json" },
          body: JSON.stringify(data),
        });

        if (res.ok) {
          toast.success("Password updated");
          setShowChangePassword(false);
        } else {
          toast.error("Update failed");
        }
      } catch {
        toast.error("Something went wrong");
      } finally {
        setLoading(false);
      }
    };

    return (
      <div style={styles.overlay}>
        <div style={styles.card}>
          <h3>Change Password</h3>

          <input
            style={styles.input}
            placeholder="Username"
            onChange={(e) => setData({ ...data, userName: e.target.value })}
          />
          <input
            style={styles.input}
            placeholder="Current Password"
            type="password"
            onChange={(e) => setData({ ...data, password: e.target.value })}
          />
          <input
            style={styles.input}
            placeholder="New Password"
            type="password"
            onChange={(e) =>
              setData({ ...data, confirmPassword: e.target.value })
            }
          />

          <button style={styles.button} onClick={submit}>
            Update
          </button>
          <p style={styles.link} onClick={() => setShowChangePassword(false)}>
            Cancel
          </p>
        </div>
      </div>
    );
  };

  return (
    <div style={styles.page}>
      {!showSignup ? (
        <div style={styles.card}>
          <img
            src="https://userrdocument.blob.core.windows.net/userdocument/companylogos/9001/2000/bf8de4a5-c86e-4ec4-b488-f90041991c9c_Stylized%203D%20gradient%20sphere%20logo.png"
            alt="logo"
            style={styles.logo}
          />

          <h2 style={styles.title}>Welcome Back</h2>

          <form onSubmit={handleLogin}>
            <input
              style={styles.input}
              placeholder="Username / Email"
              value={username}
              onChange={(e) => setUsername(e.target.value)}
            />

            <div style={styles.passwordBox}>
              <input
                style={styles.input}
                type={showPassword ? "text" : "password"}
                placeholder="Password"
                value={password}
                onChange={(e) => setPassword(e.target.value)}
              />
              <span
                style={styles.eye}
                onClick={() => setShowPassword(!showPassword)}
              >
                {showPassword ? <FaEyeSlash /> : <FaEye />}
              </span>
            </div>

            <button style={styles.button}>
              {loading ? "Logging in..." : "Log in"}
            </button>
          </form>

          <p style={styles.link} onClick={() => setShowChangePassword(true)}>
            Change Password?
          </p>

          <button style={styles.microsoftBtn} onClick={handleMicrosoftLogin}>
            Sign in with Microsoft
          </button>

          <p style={styles.link} onClick={() => setShowSignup(true)}>
            Don’t have an account? Sign up
          </p>
             <p style={styles.footer}>
        © 2026 ROSTERLEDGER™. All rights reserved
      </p>
        </div>
      ) : (
        <SignupForm />
      )}

      {showChangePassword && <ChangePassword />}
    </div>
  );
};

export default Login2;